import * as React from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import AlertDialog from "../../../../components/AlertDialog/index.es6";
import { CircularProgress, MenuItem, InputAdornment, IconButton } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import { DialogContent } from "@material-ui/core";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { PRIMARY_THEME_COLOR_SHADE_1 } from "../../../../lib/constants";

export default function UpdatePartnerConfigEmail(props) {
  const partnerConfigEmailClients = props.partnerConfigEmailClients || [];
  const partner = props.partner || {};

  const [state, setState] = React.useState(() => {
    const configEmail = props.partnerConfigEmail;
    const clients = props.partnerConfigEmailClients || [];

    if (
      configEmail &&
      configEmail.client_type &&
      clients.find((c) => c.type === configEmail.client_type)
    ) {
      return {
        ...configEmail,
        config: configEmail.config || {},
      };
    }

    return {
      client_type: "",
      config: {},
    };
  });

  // State to track visibility of sensitive fields
  const [showSensitiveFields, setShowSensitiveFields] = React.useState({});

  React.useEffect(() => {
    const configEmail = props.partnerConfigEmail;
    const clients = props.partnerConfigEmailClients || [];

    if (
      configEmail &&
      configEmail.client_type &&
      clients.find((c) => c.type === configEmail.client_type)
    ) {
      setState({
        ...configEmail,
        config: configEmail.config || {},
      });
    }
  }, [props.showUpdatePartnerConfigEmailDialog]);

  const {
    client_type,
  } = state;

  // Function to check if a field is sensitive
  const isSensitiveField = (fieldName) => {
    const sensitiveFields = ['username', 'password', 'token', 'api_key', 'secret', 'auth_token'];
    return sensitiveFields.some(sensitive =>
      fieldName.toLowerCase().includes(sensitive.toLowerCase())
    );
  };

  // Function to toggle visibility of sensitive fields
  const toggleFieldVisibility = (fieldName) => {
    setShowSensitiveFields(prev => ({
      ...prev,
      [fieldName]: !prev[fieldName]
    }));
  };

  const handleClientTypeChange = (e) => {
    const selectedType = e.target.value;

    const shouldKeepConfig =
      props.partnerConfigEmail &&
      props.partnerConfigEmail.client_type === selectedType &&
      !!props.partnerConfigEmail.config;

    setState((prevState) => ({
      ...prevState,
      client_type: selectedType,
      config: shouldKeepConfig ? props.partnerConfigEmail.config : {},
    }));

    // Reset visibility state when client type changes
    setShowSensitiveFields({});
  };

  const handleConfigChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      config: {
        ...prevState.config,
        [name]: value,
      },
    }));
  };

  const submit = () => {
    const payload = {
      partner: partner.guid,
      client_type: state.client_type,
      config: state.config,
      description: `Email configurations for partner ${partner.guid}`,
    };

    Object.keys(payload).forEach((k) => {
      if (payload[k] === null || payload[k] === undefined) {
        delete payload[k];
      }
    });

    props.updatePartnerConfigEmail(payload);
  };

  const reset = () => {
    setState(props.partnerConfigEmail || {});
    setShowSensitiveFields({});
  };

  const handleUpdateParnterConfigEmailSuccessfully = () => {
    props.resetUpdatePartnerConfigEmailSuccessAlert();
    props.closeUpdatePartnerConfigEmailDialog();
    reset();
  };

  const handleUpdateParnterConfigEmailError = () => {
    props.resetUpdatePartnerConfigEmailErrorAlert();
  };

  const selectedClient = partnerConfigEmailClients && client_type
    ? partnerConfigEmailClients.find(client => client.type === client_type)
    : null;

  return (
    <>
      <AlertDialog
        custom
        show={props.showUpdatePartnerConfigEmailProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2>updating partner config email</h2>
      </AlertDialog>

      <AlertDialog
        success
        show={props.showUpdatePartnerConfigEmailSuccessAlert}
        size="sm"
        title={'Partner config email updated'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={handleUpdateParnterConfigEmailSuccessfully}
        confirmBtnText={'ok'}
        showCancel={false}
        cancelBtnText={'cancel'}
        confirmBtnCssClass
      />

      <AlertDialog
        show={props.showUpdatePartnerConfigEmailErrorAlert}
        danger
        title={'Error updating partner config email'}
        onConfirm={handleUpdateParnterConfigEmailError}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        {props.updatePartnerConfigEmailError ? props.updatePartnerConfigEmailError.message : ''}
      </AlertDialog>

      <Dialog open={props.showUpdatePartnerConfigEmailDialog} fullWidth maxWidth='lg' fullScreen onClose={props.closeUpdatePartnerConfigEmailDialog}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar style={{ background: PRIMARY_THEME_COLOR_SHADE_1 }}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.closeUpdatePartnerConfigEmailDialog}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Update Partner Config email
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <Box sx={{ width: "100%", mt: 2 }}>
            <ValidatorForm onSubmit={submit}>
              <Grid container spacing={2}>
                <Grid item lg={4} md={4} xs={12}>
                  <TextValidator
                    select
                    fullWidth
                    name="client_type"
                    label="Email Client Type"
                    value={client_type || ""}
                    onChange={handleClientTypeChange}
                    variant="outlined"
                    validators={["required"]}
                    errorMessages={["Client Type is required"]}
                  >
                    {partnerConfigEmailClients.map((client) => (
                      <MenuItem key={client.type} value={client.type}>
                        {client.name}
                      </MenuItem>
                    ))}
                  </TextValidator>
                </Grid>

                {selectedClient && selectedClient.required_params && selectedClient.required_params.map((param) => {
                  const isSensitive = isSensitiveField(param);
                  const isVisible = showSensitiveFields[param];
                  const fieldValue = (state.config && state.config[param]) || "";
                  const displayValue = isSensitive && fieldValue && !isVisible ? '************************' : fieldValue;

                  return (
                    <Grid item lg={4} md={4} xs={12} key={param}>
                      <TextValidator
                        fullWidth
                        label={param}
                        name={param}
                        value={displayValue}
                        onChange={handleConfigChange}
                        variant="outlined"
                        validators={["required"]}
                        errorMessages={[`${param} is required`]}
                        type={isSensitive && !isVisible ? "password" : "text"}
                        InputProps={isSensitive && fieldValue ? {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => toggleFieldVisibility(param)}
                                edge="end"
                              >
                                {isVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        } : undefined}
                      />
                    </Grid>
                  );
                })}

                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button variant="contained" type="submit" style={{ marginRight: '2%' }}> Update </Button>
                  <Button variant="contained" color="secondary" style={{ marginRight: '2%' }}
                    onClick={() => reset()}
                  > Reset</Button>
                </Grid>

              </Grid>
            </ValidatorForm>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}